import _ from 'lodash';

export interface PaginationConfig {
    key: number;
    value: number;
    text: string;
}
export const PAGINATION_OPTIONS: PaginationConfig[] = [
    { key: 10, value: 10, text: '10' },
    { key: 20, value: 20, text: '20' },
    { key: 30, value: 30, text: '30' },
    { key: 50, value: 50, text: '50' },
];

export const PAGINATION_VALUES = _.map(PAGINATION_OPTIONS, (option) => option.value);
export const DEFAULT_PAGE_SELECTED = 1;
export const DEFAULT_PAGE_SIZE = 20;
